import React from 'react';
import { useIntl } from 'react-intl';

import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';

import styles from './dialog-wizard.scss';

export interface DialogWizardLoadingScreenProps {
  text?: string;
}

export const DialogWizardLoadingScreen = ({ text }: DialogWizardLoadingScreenProps) => {
  const intl = useIntl();

  const defaultText = intl.formatMessage({
    id: 'common.loading_please_wait',
    defaultMessage: 'Loading, please wait...'
  });

  return (
    <div className={styles.loadingContainer} data-testid="dialog-wizard-loading">
      <LoaderSpinner mx="3" spinnerLabel={text || defaultText} variant="action" />
    </div>
  );
};
